<template>
  <div class="card-mgt-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("sale.card.title1") }}</span>
      <span v-else>编辑礼品卡</span>
      <div>
        <button class="global-button-style" @click="$router.back()">
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="card"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item :label="$t('sale.card.name')" prop="title">
            <el-input  style="width: 200px"
              v-model="card.title"
              class="fl"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="card.type">
              <el-radio label="gift">礼品卡</el-radio>
              <el-radio label="goods">商品卡</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="'价格'">
            <el-input v-model="card.price" style="width: 200px" type="number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('sale.card.liveAt')" prop="endAt">
            <el-date-picker
              type="datetime"
              :placeholder="$t('sale.card.liveAt')"
              v-model="card.liveAt"
              :picker-options="pickerOptions"
              style="width: 200px"
            ></el-date-picker>
          </el-form-item>
          <div v-if="!$route.query.id">
            <el-form-item :label="'添加'" v-if="userInfo.roleValue === 1">
              <el-upload
                class="fl"
                action=""
                :auto-upload="false"
                :on-change="importPhone"
                :show-file-list="false"
              >
                <span class="card-mgt-fileName" v-if="userFile">{{
                  userFile.name
                }}</span>
                <el-button size="small" type="primary">导入</el-button>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  data() {
    return {
      card: {
        title: "",
        liveAt: "",
        type: "gift",
        price: 0
      },
      userFile: null,
      rules: {
        codeList: [
          {
            required: true,
            message: "礼品卡号不能为空",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "礼品卡号不能为空",
            trigger: "blur"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24*60*60*1000;
        }
      }
    };
  },
  methods: {
    importPhone(file) {
      this.userFile = file;
    },
    getcardDetails() {
      this.$http.getCardDetails({id: this.$route.query.id}).then(ret => {
        for (let item in this.card) {
          this.card[item] = ret.data.cardHolder[item];
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    create() {
      if (this.userInfo.roleValue === 1) {
        this.userFile
          ? (this.card.code = this.userFile.raw)
          : delete this.card.code;
      } else {
        delete this.card.code;
      }
      let form = new FormData();
      let keys = Object.keys(this.card);
      keys.forEach(key => {
        form.append(key, this.card[key]);
      });
      this.$http.addCard(form).then(res => {

        if (res.data.sucessCount===0) {
          this.elMsg(this.$t("sale.card.import")+this.$t("sale.card.success")+res.data.sucessCount+', '+this.$t("sale.card.fail")+res.data.faildCount+this.$t("sale.card.item"), "warning");
        } else {
          this.elMsg(this.$t("sale.card.import")+this.$t("sale.card.success")+res.data.sucessCount+', '+this.$t("sale.card.fail")+res.data.faildCount+this.$t("sale.card.item"), "success");
        }

        // this.elMsg(this.$t("alertMsg.addSuccess"), "success");
        this.$router.back();
      });
    },

    edit() {
      let form = new FormData();
      let keys = Object.keys(this.card);
      keys.forEach(key => {
        form.append(key, this.card[key]);
      });
      this.$http.editCard(this.$route.query.id, form).then(res => {
        this.elMsg(this.$t("alertMsg.modifySuccess"), "success");
        this.$router.back();
      });
    }
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getcardDetails();
  }
};
</script>

<style lang="scss">
.card-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .card-mgt-fileName {
        margin-right: 10px;
      }
      .card-import-btn {
        margin-top: 10px;
      }
    }
  }
}
</style>
